import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Table from "../../Components/Script/Table";
import { getAllServiceApplications, getServiceApplicationById, updateApplicationStatus } from "../../Services/dynamicservice"
import { createPaymentOrder, verifyPayment } from "../../Services/paymentService";
import $ from "jquery";

function AllServiceApplicationAdmin() {
    const [applications, setApplications] = useState([]);
    const [loading, setLoading] = useState(true);
    const tableRef = useRef(null);
    const [selectedApplication, setSelectedApplication] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [previewFile, setPreviewFile] = useState(null);
    const [previewType, setPreviewType] = useState(null);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [statusUpdate, setStatusUpdate] = useState("");
    const [remarks, setRemarks] = useState("");
    const [isEditing, setIsEditing] = useState(false);

    const [showRemarksModal, setShowRemarksModal] = useState(false);
    const [selectedRemarks, setSelectedRemarks] = useState("");

    const openRemarksModal = (remarks) => {
        setSelectedRemarks(remarks);
        setShowRemarksModal(true);
    };

    const closeRemarksModal = () => {
        setShowRemarksModal(false);
        setSelectedRemarks("");
    };

    const getApplicantName = (formDataString) => {
        if (!formDataString) return "-";

        let data = {};

        try {
            data = JSON.parse(formDataString);
        } catch {
            return "-";
        }

        let firstName = "";
        let lastName = "";
        let fullName = "";

        Object.entries(data).forEach(([key, value]) => {
            const lowerKey = key.toLowerCase();

            if (lowerKey.includes("name") || lowerKey === "name") {
                fullName = value;
            }

            if (lowerKey.includes("first name")) {
                firstName = value;
            }

            if (lowerKey.includes("last name")) {
                lastName = value;
            }
        });

        if (fullName) return fullName;

        const combined = `${firstName} ${lastName}`.trim();

        return combined || "-";
    };


    useEffect(() => {
        fetchApplications();
    }, []);

    useEffect(() => {
        if (
            loading ||
            !applications.length ||
            !tableRef.current ||
            !window.$ ||
            !$.fn ||
            !$.fn.DataTable
        ) {
            return;
        }

        const table = $(tableRef.current);

        if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().destroy();
        }

        setTimeout(() => {
            table.DataTable({
                scrollX: true
            });
        }, 0);
    }, [loading, applications]);

    const handleFilePreview = (url) => {

        const extension = url.split('.').pop().toLowerCase();

        if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
            setPreviewType("image");
        }
        else if (extension === "pdf") {
            setPreviewType("pdf");
        }
        else {
            window.open(url, "_blank");
            return;
        }

        setPreviewFile(url);
        setZoomLevel(1);
    };

    const zoomIn = () => {
        setZoomLevel(prev => prev + 0.2);
    };

    const zoomOut = () => {
        setZoomLevel(prev => (prev > 0.4 ? prev - 0.2 : prev));
    };

    const resetZoom = () => {
        setZoomLevel(1);
    };




    const handleView = async (id) => {
        try {
            const data = await getServiceApplicationById(id);

            setSelectedApplication(data);
            setStatusUpdate(data.applicationStatus);
            setRemarks(data.remarks || "");

            setIsEditing(false);   // disable editing initially
            setShowModal(true);
        } catch (error) {
            console.error(error);
            alert("Unable to fetch application details");
        }
    };

    const handleStatusUpdate = async () => {

        try {

            await updateApplicationStatus(selectedApplication.id, {
                status: parseInt(statusUpdate),
                remarks: remarks,
                // assignedTo:'3fa85f64-5717-4562-b3fc-2c963f66afa6'
            });

            alert("Application updated successfully");

            setShowModal(false);

            fetchApplications();

        } catch (error) {

            console.error(error);
            alert("Failed to update application");

        }
    };

    const parsedFormData = selectedApplication?.formData
        ? JSON.parse(selectedApplication.formData)
        : {};

    const handlePayment = async (applicationId) => {
        try {
            const orderData = await createPaymentOrder(applicationId);

            const options = {
                key: orderData.key,
                amount: orderData.amount * 100,
                currency: "INR",
                order_id: orderData.orderId,
                name: "Service Application Payment",
                description: "Application Fee Payment",

                handler: async function (response) {
                    await verifyPayment({
                        applicationId: applicationId,
                        orderId: response.razorpay_order_id,
                        paymentId: response.razorpay_payment_id,
                        signature: response.razorpay_signature
                    });

                    alert("Payment Successful");
                    fetchApplications(); // refresh table
                },

                modal: {
                    ondismiss: function () {
                        alert("Payment cancelled");
                    }
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();

        } catch (error) {
            alert("Unable to initiate payment");
        }
    };


    const fetchApplications = async () => {
        try {
            setLoading(true);
            const data = await getAllServiceApplications();
            const sortedData = data.sort(
                (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
            );
            setApplications(sortedData);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">

                            {/* Page Title */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    All Service Applications
                                                </li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">
                                            All Service Applications
                                        </h4>
                                    </div>
                                </div>
                            </div>

                            {/* Table Section */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">

                                            <div className="table-responsive">
                                                <table
                                                    ref={tableRef}
                                                    className="table table-striped table-bordered table-hover nowrap row-border order-column w-100"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Action</th>
                                                            <th>Created By</th>
                                                            <th>Lead Id</th>
                                                            <th>Applicant Name</th>
                                                            <th>Service Name</th>
                                                            {/* <th>User Name</th> */}
                                                            <th>Payment Amount</th>
                                                            <th>Payment Status</th>
                                                            <th>Application Status</th>

                                                            <th>Created Date</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {applications.length > 0 ? (
                                                            applications.map((app) => {

                                                                const paymentStatusText =
                                                                    app.paymentStatus === 0 ? "Pending" :
                                                                        app.paymentStatus === 1 ? "Paid" :
                                                                            "Failed";

                                                                const applicationStatusText =
                                                                    app.applicationStatus === 0 ? "Submitted" :
                                                                        app.applicationStatus === 1 ? "DocumentPending" :
                                                                            app.applicationStatus === 2 ? "InProgress" :
                                                                                app.applicationStatus === 3 ? "Approved" :
                                                                                    app.applicationStatus === 4 ? "Rejected" :
                                                                                        app.applicationStatus === 5 ? "Completed" :
                                                                                            "OnHold";

                                                                return (
                                                                    <tr key={app.id}>
                                                                        <td>
                                                                            <button
                                                                                className="btn btn-sm btn-primary"
                                                                                onClick={() => handleView(app.id)}
                                                                            >
                                                                                View
                                                                            </button>
                                                                        </td>

                                                                        <td>
                                                                            {app.user.name}{' '} <br />
                                                                            <a href={`tel:${app.user.mobile}`}>
                                                                                {app.user.mobile}
                                                                            </a>
                                                                        </td>
                                                                        <td>{app.leadNumber}</td>
                                                                        <td>
                                                                            <strong>{getApplicantName(app.formData)}</strong>

                                                                        </td>
                                                                        <td>{app.service?.name}</td>
                                                                        {/* <td>{app.user?.name}</td> */}
                                                                        <td>₹ {app.paymentAmount}</td>

                                                                        <td>
                                                                            {app.paymentStatus === 0 ? (
                                                                                <span
                                                                                    className="badge bg-warning"

                                                                                >
                                                                                    {paymentStatusText}
                                                                                </span>
                                                                            ) : (
                                                                                <span className={`badge ${app.paymentStatus === 0
                                                                                    ? "bg-info"
                                                                                    : app.paymentStatus === 1
                                                                                        ? "bg-success"
                                                                                        : app.paymentStatus === 2
                                                                                            ? "bg-danger"
                                                                                            : "bg-secondary"
                                                                                    }`}>
                                                                                    {paymentStatusText}
                                                                                </span>
                                                                            )}
                                                                        </td>

                                                                        <td>
                                                                            <span
                                                                                className={`badge ${app.applicationStatus === 0
                                                                                    ? "bg-info"
                                                                                    : app.applicationStatus === 1
                                                                                        ? "bg-success"
                                                                                        : app.applicationStatus === 2
                                                                                            ? "bg-danger"
                                                                                            : "bg-secondary"
                                                                                    }`}
                                                                            >
                                                                                {applicationStatusText}
                                                                            </span>

                                                                            {app.remarks && (
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-primary ms-2"
                                                                                    onClick={() => openRemarksModal(app.remarks)}
                                                                                >
                                                                                    View
                                                                                </button>

                                                                            )}
                                                                        </td>

                                                                        <td>
                                                                            {new Date(app.createdAt).toLocaleString()}
                                                                        </td>


                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="7" className="text-center">No Data Found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {showRemarksModal && (
                                                <div className="modal fade show d-block">
                                                    <div className="modal-dialog modal-dialog-centered">
                                                        <div className="modal-content">

                                                            {/* Header */}
                                                            <div className="modal-header">
                                                                <h5 className="modal-title">Remarks</h5>
                                                                <button
                                                                    className="btn-close"
                                                                    onClick={closeRemarksModal}
                                                                ></button>
                                                            </div>

                                                            {/* Body */}
                                                            <div
                                                                className="modal-body"
                                                                style={{ maxHeight: "300px", overflowY: "auto" }}
                                                            >
                                                                {selectedRemarks}
                                                            </div>

                                                            {/* Footer */}
                                                            <div className="modal-footer">
                                                                <button
                                                                    className="btn btn-secondary"
                                                                    onClick={closeRemarksModal}
                                                                >
                                                                    Close
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Backdrop */}

                                                </div>

                                            )}

                                            {showModal && selectedApplication && (() => {

                                                const formData = selectedApplication.formData
                                                    ? JSON.parse(selectedApplication.formData)
                                                    : {};

                                                const paymentStatusText =
                                                    selectedApplication.paymentStatus === 0 ? "Pending" :
                                                        selectedApplication.paymentStatus === 1 ? "Paid" :
                                                            "Failed";

                                                const applicationStatusText =
                                                    selectedApplication.applicationStatus === 0 ? "Submitted" :
                                                        selectedApplication.applicationStatus === 1 ? "Document Pending" :
                                                            selectedApplication.applicationStatus === 2 ? "In Progress" :
                                                                selectedApplication.applicationStatus === 3 ? "Approved" :
                                                                    selectedApplication.applicationStatus === 4 ? "Rejected" :
                                                                        selectedApplication.applicationStatus === 5 ? "Completed" :
                                                                            "On Hold";

                                                return (

                                                    <div className="modal fade show d-block application-modal">
                                                        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                                                            <div className="modal-content shadow-lg border-0 rounded-4">

                                                                {/* Header */}
                                                                <div className="modal-header bg-primary text-white rounded-top-4">
                                                                    <h5 className="modal-title fw-bold">
                                                                        Service Application Details
                                                                    </h5>

                                                                    <button
                                                                        className="btn-close btn-close-white"
                                                                        onClick={() => setShowModal(false)}
                                                                    ></button>
                                                                </div>

                                                                {/* Body */}
                                                                <div className="modal-body">

                                                                    <div className="container-fluid">

                                                                        <div className="row g-4">

                                                                            {/* Application Info */}
                                                                            <div className="col-lg-6 col-md-12">

                                                                                <div className="card shadow-sm h-100 border-0">
                                                                                    <div className="card-header bg-light fw-bold">
                                                                                        Application Info
                                                                                    </div>

                                                                                    <div className="card-body">

                                                                                        <div className="info-row">
                                                                                            <label>Application ID</label>
                                                                                            <span>{selectedApplication.id}</span>
                                                                                        </div>

                                                                                        <div className="info-row">
                                                                                            <label>Payment Amount</label>
                                                                                            <span>₹ {selectedApplication.paymentAmount}</span>
                                                                                        </div>

                                                                                        <div className="info-row">
                                                                                            <label>Payment Status</label>
                                                                                            <span className="badge bg-success">
                                                                                                {paymentStatusText}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className="info-row">
                                                                                            <label>Application Status</label>
                                                                                            <span className="badge bg-info">
                                                                                                {applicationStatusText}
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className="info-row mt-3">
                                                                                            <label>Update Status</label>

                                                                                            <select
                                                                                                className="form-control"
                                                                                                value={statusUpdate}
                                                                                                disabled={!isEditing}
                                                                                                onChange={(e) => setStatusUpdate(e.target.value)}
                                                                                            >

                                                                                                <option value="0">Submitted</option>
                                                                                                <option value="1">Document Pending</option>
                                                                                                <option value="2">In Progress</option>
                                                                                                <option value="3">Approved</option>
                                                                                                <option value="4">Rejected</option>
                                                                                                <option value="5">Completed</option>
                                                                                                <option value="6">On Hold</option>

                                                                                            </select>
                                                                                        </div>

                                                                                        <div className="info-row mt-3">

                                                                                            <label>Remarks</label>

                                                                                            <textarea
                                                                                                className="form-control"
                                                                                                rows="3"
                                                                                                value={remarks}
                                                                                                disabled={!isEditing}
                                                                                                onChange={(e) => setRemarks(e.target.value)}
                                                                                            />

                                                                                        </div>

                                                                                        <div className="info-row">
                                                                                            <label>Payment Reference</label>
                                                                                            <span>{selectedApplication.paymentReferenceId}</span>
                                                                                        </div>

                                                                                        <div className="info-row">
                                                                                            <label>Created Date</label>
                                                                                            <span>
                                                                                                {new Date(selectedApplication.createdAt).toLocaleString()}
                                                                                            </span>
                                                                                        </div>

                                                                                    </div>
                                                                                </div>

                                                                            </div>


                                                                            {/* Applicant Details */}
                                                                            <div className="col-lg-6 col-md-12">

                                                                                <div className="card shadow-sm h-100 border-0">
                                                                                    <div className="card-header bg-light fw-bold">
                                                                                        Applicant Details
                                                                                    </div>

                                                                                    <div className="card-body">

                                                                                        {Object.entries(formData).map(([key, value]) => {

                                                                                            const extension = value?.split('.').pop()?.toLowerCase();

                                                                                            const isFile =
                                                                                                ["jpg", "jpeg", "png", "gif", "webp", "pdf"].includes(extension);

                                                                                            return (
                                                                                                <div className="info-row" key={key}>

                                                                                                    <label>
                                                                                                        {key.replace(/([A-Z])/g, " $1")}
                                                                                                    </label>

                                                                                                    <span>

                                                                                                        {isFile ? (

                                                                                                            <div
                                                                                                                className="file-preview"
                                                                                                                onClick={() => handleFilePreview(value)}
                                                                                                            >

                                                                                                                {extension === "pdf" ? (

                                                                                                                    <div className="pdf-preview">
                                                                                                                        📄 View PDF
                                                                                                                    </div>

                                                                                                                ) : (

                                                                                                                    <img
                                                                                                                        src={value}
                                                                                                                        alt={key}
                                                                                                                        className="img-preview"
                                                                                                                    />

                                                                                                                )}

                                                                                                            </div>

                                                                                                        ) : (
                                                                                                            value
                                                                                                        )}

                                                                                                    </span>

                                                                                                </div>
                                                                                            );
                                                                                        })}

                                                                                    </div>
                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                {/* Footer */}
                                                                <div className="modal-footer">

                                                                    {!isEditing && (
                                                                        <button
                                                                            className="btn btn-warning"
                                                                            onClick={() => setIsEditing(true)}
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                    )}

                                                                    {isEditing && (
                                                                        <button
                                                                            className="btn btn-success"
                                                                            onClick={handleStatusUpdate}
                                                                        >
                                                                            Update Status
                                                                        </button>
                                                                    )}

                                                                    <button
                                                                        className="btn btn-secondary"
                                                                        onClick={() => setShowModal(false)}
                                                                    >
                                                                        Close
                                                                    </button>

                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                );

                                            })()}
                                            {previewFile && (

                                                <div className="modal fade show d-block file-preview-modal">
                                                    <div className="modal-dialog modal-fullscreen">
                                                        <div className="modal-content bg-dark text-white">

                                                            {/* Header */}
                                                            <div className="modal-header border-0">

                                                                <div className="d-flex gap-2">

                                                                    {previewType === "image" && (
                                                                        <>
                                                                            <button className="btn btn-light btn-sm" onClick={zoomIn}>
                                                                                🔍+
                                                                            </button>

                                                                            <button className="btn btn-light btn-sm" onClick={zoomOut}>
                                                                                🔍-
                                                                            </button>

                                                                            <button className="btn btn-light btn-sm" onClick={resetZoom}>
                                                                                Reset
                                                                            </button>
                                                                        </>
                                                                    )}



                                                                </div>

                                                                <button
                                                                    className="btn-close btn-close-white"
                                                                    onClick={() => setPreviewFile(null)}
                                                                ></button>

                                                            </div>

                                                            {/* Body */}
                                                            <div className="modal-body text-center preview-container">

                                                                {previewType === "image" && (
                                                                    <img
                                                                        src={previewFile}
                                                                        alt="preview"
                                                                        style={{
                                                                            transform: `scale(${zoomLevel})`,
                                                                            transition: "transform 0.2s"
                                                                        }}
                                                                        className="preview-image"
                                                                    />
                                                                )}

                                                                {previewType === "pdf" && (
                                                                    <iframe
                                                                        src={previewFile}
                                                                        title="PDF Preview"
                                                                        className="pdf-frame"
                                                                    ></iframe>
                                                                )}

                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>

                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AllServiceApplicationAdmin;